// extracted by mini-css-extract-plugin
export var centerGradient = "staticGradient-module--centerGradient--67947";
export var staticgradient = "staticGradient-module--staticgradient--c158a";